import MyBag from './MyBag';

export default MyBag;
